import React, { useEffect, useState, useMemo } from "react";
import Footer from "./Footer";
import { Link } from "react-router-dom";
import Header from "./Header";
import { Container, Row, Col } from "react-bootstrap";

const baseLinkConfig = (isLoggedIn) => [
  
  {
    to: "/Mycart",
    iconClass: "fa fa-shopping-cart white",
    iconBgClass: "bg-mint-dark rounded-s",
    label: "My Selection",
    color: "#10b981",
    iconStyle: {
      backgroundColor: "#10b981",
      color: "white",
      borderRadius: "10px",
    },
  },
  {
    to: "/MyOrderds",
    iconClass: "fa fa-heart white",
    iconBgClass: "bg-green-dark rounded-s",
    label: "My Orders",
    color: "#ef4444",
    iconStyle: {
      backgroundColor: "#ef4444",
      color: "white",
      borderRadius: "10px",
    },
  },
   {
    to: "/AddProduct",
     iconClass: "fa fa-search white",
    label: "All Products",
    color: "#ff7b56",
    iconStyle: {
      backgroundColor: "#ff7b56",
      color: "white",
      borderRadius: "10px",
    },
  },
  {
    to: "/UpdateBankDetails",
    iconClass: "fa fa-list-alt white",
    iconBgClass: "bg-blue-dark rounded-s",
    label: "Bank Details",
    color: "#3b82f6",
    iconStyle: {
      backgroundColor: "#3b82f6",
      color: "white",
      borderRadius: "10px",
    },
  },
  
  {
    to: "/MyTransaction",
    iconClass: "fa fa-exchange-alt white",
    iconBgClass: "bg-yellow-dark rounded-s",
    label: "My Transaction",
    color: "#f59e0b",
    iconStyle: {
      backgroundColor: "#f59e0b",
      color: "white",
      borderRadius: "10px",
    },
  },
  {
    to: "/Complain",
    iconClass: "fa fa-comments white",
    iconBgClass: "bg-facebook rounded-s",
    label: "Complain",
    color: "#3b82f6",
    iconStyle: {
      backgroundColor: "#3b82f6",
      color: "white",
      borderRadius: "10px",
    },
  },
 
  {
    to: "/MyDevice",
    iconClass: "fa fa-mobile-alt white",
    label: "My Device",
    color: "#d47808",
    iconStyle: {
      backgroundColor: "rgb(215 120 8)",
      color: "white",
      borderRadius: "10px",
    },
  },
  isLoggedIn
    ? {
        to: "/Logout",
        iconClass: "fa fa-sign-out white",
        iconBgClass: "bg-red-dark rounded-s",
        label: "Logout",
        color: "#ef4444",
        iconStyle: {
          backgroundColor: "#ef4444",
          color: "white",
          borderRadius: "10px",
        },
      }
    : {
        to: "/Login", // Changed from "/Logout" to "/Login"
        iconClass: "fa fa-sign-in-alt white",
        iconBgClass: "bg-green-dark rounded-s",
        label: "Login",
        color: "#10b981",
        iconStyle: {
          backgroundColor: "#10b981",
          color: "white",
          borderRadius: "10px",
        },
      },
].filter(Boolean);

const updateProfileButtonStyle = {
  padding: "15px 15px !important",
  background: "#000000",
  fontSize: "18px",
  border: "0.5px solid #ddd",
};

function More() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [dealerId, setDealerId] = useState(null);

  // Get dealerId from localStorage on component mount and when it changes
  useEffect(() => {
    const checkLoginStatus = () => {
      const id = localStorage.getItem("LoginNumber");
      setDealerId(id);
    };

    // Check initially
    checkLoginStatus();

    // Set up storage event listener to detect changes from other tabs/windows
    const handleStorageChange = (e) => {
      if (e.key === "LoginNumber") {
        checkLoginStatus();
      }
    };

    // Listen for storage changes
    window.addEventListener('storage', handleStorageChange);

    // Poll for changes (optional, for same tab changes)
    const intervalId = setInterval(checkLoginStatus, 1000);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      clearInterval(intervalId);
    };
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Memoize the link configurations based on dealerId
  const mobileLinkConfig = useMemo(() => 
    baseLinkConfig(!!dealerId), [dealerId]
  );

  const webLinkConfig = useMemo(() => 
    baseLinkConfig(!!dealerId), [dealerId]
  );

  const dealerInfo = useMemo(
    () => ({
      firmName: dealerId ? localStorage.getItem("dealer_firm_name") : "Please Login",
      mobile: dealerId ? localStorage.getItem("dealer_login_mobile") : "",
      email: dealerId ? localStorage.getItem("dealer_email") : "",
    }),
    [dealerId] // Re-calc when dealerId changes
  );

  return (
    <>
      {isMobile ? (
        <>
          <div
            className="page-content header-clear-small"
            style={{
              paddingBottom: "calc(70px + env(safe-area-inset-bottom) * 1.3)",
              backgroundColor: "#ffffff",
            }}
          >
            <div
              className="card card-style preload-img"
              data-src="images/pictures/18w.jpg"
              style={{ height: "100px", background: "#ffffff", borderBottom: "1px solid #e5e5e5" }}
            >
              <div className="card-center ms-3">
                <h1 className="mb-0" style={{ color: "#000000" }}>{dealerInfo.firmName}</h1>
                <p className="mt-n1 mb-0" style={{ color: "#333333" }}>{dealerInfo.mobile}</p>
                <p className="mt-n1 mb-0" style={{ color: "#333333" }}>{dealerInfo.email}</p>
              </div>
              {dealerId && (
                <div className="card-center me-3">
                  <Link
                    style={updateProfileButtonStyle}
                    to="/UpdateProdile"
                    className="btn float-end"
                  >
                    <i
                      className="fa fa-pencil rounded-s"
                      style={{ color: "#ffffff" }}
                    ></i>
                  </Link>
                </div>
              )}
              <div
                className="card-overlay  opacity-80"
                style={{ background: "transparent" }}
              ></div>
            </div>

            <div
              className="card card-style"
              style={{ marginTop: "15px", background: "#ffffff", boxShadow: "0 2px 8px rgba(0,0,0,0.05)" }}
            >
              <div className="content mt-0 mb-0">
                <div className="list-group list-custom-large short-border check-visited">
                  {mobileLinkConfig.map((link, index) => (
                    <Link
                      key={index}
                      to={link.to}
                      className={link.linkClass || ""}
                      style={{ borderBottom: "1px solid #f0f0f0" }}
                    >
                      <i
                        className={link.iconClass}
                        style={link.iconStyle || {}}
                        aria-hidden="true"
                      ></i>
                      <span style={{ color: "#000000" }}>{link.label}</span>
                      <i
                        className="fa fa-angle-right"
                        style={{ color: "#333333" }}
                      ></i>
                    </Link>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </>
      ) : (
        <>
          <React.Fragment>
            <Header />
            <div className="more-page">
              {/* Profile Section */}
              <section className="profile-section">
                <div
                  className="profile-bg"
                  style={{
                    paddingLeft: "25px",
                    background: "#ffffff",
                    borderBottom: "1px solid #e5e5e5",
                  }}
                >
                  <Container className="py-5">
                    <Row className="align-items-center">
                      <Col md={8} lg={9}>
                        <div className="profile-info">
                          <h1 className="profile-title" style={{ color: "#000000" }}>
                            {dealerInfo.firmName}
                          </h1>
                          <p className="profile-detail mb-2" style={{ color: "#333333" }}>
                            {dealerInfo.mobile}
                          </p>
                          <p className="profile-detail" style={{ color: "#333333" }}>{dealerInfo.email}</p>
                        </div>
                      </Col>
                      {dealerId && (
                        <Col md={4} lg={3} className="text-md-end mt-4 mt-md-0">
                          <Link to="/UpdateProdile" className="edit-profile-btn">
                            <i className="fa fa-pencil-alt me-2 white" ></i>
                            Edit Profile
                          </Link>
                        </Col>
                      )}
                    </Row>
                  </Container>
                </div>
              </section>

              {/* Menu Section */}
              <section className="menu-section">
                <Container className="py-5 py5">
                  <Row className="g-4">
                    {webLinkConfig.map((link, index) => (
                      <Col xs={6} sm={4} md={3} lg={3} key={index}>
                        <Link to={link.to} className="menu-card-link">
                          <div className="menu-card">
                            <div
                              className="menu-icon"
                              style={{ backgroundColor: link.color }}
                            >
                              <i
                                className={link.iconClass}
                                aria-hidden="true"
                              ></i>
                            </div>
                            <h5 className="menu-label" style={{ color: "#000000" }}>{link.label}</h5>
                            <i className="fa fa-arrow-right menu-arrow"></i>
                          </div>
                        </Link>
                      </Col>
                    ))}
                  </Row>
                </Container>
              </section>

              <br />
            </div>
            <Footer />

            <style jsx>{`
              /* ... keep all your existing styles ... */
              .white{
                color:white !important;
              }
              .page-content {
                padding-bottom: calc(60px + env(safe-area-inset-bottom) * 1.1);
              }
              .mt-4 {
                padding-top: 0rem !important;
                padding-bottom: 2rem !important;
              }
              .py-5 {
                padding-top: 1rem !important;
                padding-bottom: 0rem !important;
              }

              .py5 {
                padding-top: 3rem !important;
              }

              .row {
                margin-bottom: 0px;
              }

              .more-page {
                background: #ffffff;
                min-height: 83vh;
                color: #000000;
                font-family: -apple-system, BlinkMacSystemFont, "Segoe UI",
                  Roboto, sans-serif;
              }

              
              /* Profile Section */
              .profile-section {
                margin-bottom: 0;
              }

              .profile-bg {
                background: #ffffff;
                border-bottom: 1px solid #e5e5e5;
                position: relative;
                overflow: hidden;
              }

              .profile-bg::before {
                content: "";
                position: absolute;
                left: 0;
                right: 0;
                bottom: 0;
                background-size: cover;
                opacity: 0.1;
                z-index: 1;
              }

              .profile-info {
                position: relative;
                z-index: 2;
                padding: 20px 0;
              }

              .profile-title {
                font-size: large;
                font-weight: 700;
                margin-bottom: 0.5rem;
                color: #000000;
              }

              .profile-detail {
                font-size: large;
                color: #333333;
                margin-bottom: 0;
                opacity: 0.9;
              }

              .edit-profile-btn {
                display: inline-flex;
                align-items: center;
                background: #000000;
                color: white;
                padding: 12px 24px;
                border-radius: 50px;
                text-decoration: none;
                font-weight: 600;
                font-size: large;
                transition: all 0.3s ease;
                box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
                border: 1px solid #000000;
              }

              .edit-profile-btn:hover {
                transform: translateY(-2px);
                box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);
                color: white;
                text-decoration: none;
                background: #333333;
              }

              /* Menu Section */
              .menu-section {
                background: #f8f9fa;
              }

              .menu-card-link {
                text-decoration: none;
                display: block;
                height: 100%;
              }

              .menu-card {
                background: #ffffff;
                border-radius: 16px;
                padding: 24px 20px;
                height: 100%;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                text-align: center;
                transition: all 0.3s ease;
                border: 1px solid #e5e5e5;
                box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
                position: relative;
                overflow: hidden;
              }

              .menu-card::before {
                content: "";
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                height: 4px;
                background: linear-gradient(
                  90deg,
                  var(--card-color, #db4437) 0%,
                  transparent 100%
                );
                opacity: 0;
                transition: opacity 0.3s ease;
              }

              .menu-card:hover {
                transform: translateY(-8px);
                box-shadow: 0 12px 30px rgba(0, 0, 0, 0.1);
                border-color: var(--card-color, #db4437);
                background: #ffffff;
              }

              .menu-card:hover::before {
                opacity: 1;
              }

              .menu-icon {
                width: 60px;
                height: 60px;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-bottom: 16px;
                transition: transform 0.3s ease;
                flex-shrink: 0;
              }

              .menu-card:hover .menu-icon {
                transform: scale(1.1);
              }

              .menu-icon i {
                font-size: 24px;
                color: white;
              }

              .menu-label {
                font-size: large;
                font-weight: 600;
                color: #000000;
                margin-bottom: 12px;
                line-height: 1.3;
                flex-grow: 1;
                display: flex;
                align-items: center;
              }

              .menu-arrow {
                color: #999;
                font-size: 14px;
                opacity: 0;
                transition: all 0.3s ease;
                align-self: flex-end;
              }

              .menu-card:hover .menu-arrow {
                opacity: 1;
                color: var(--card-color, #db4437);
                transform: translateX(4px);
              }

              /* Version Section */
              .version-section {
                border-top: 1px solid #e5e5e5;
                background: #ffffff;
              }

              .version-text {
                color: #666;
                font-size: 0.9rem;
                margin: 0;
                opacity: 0.7;
              }

              /* Responsive Design */
              @media (max-width: 768px) {
                .profile-title {
                  font-size: 2rem;
                }

                .profile-detail {
                  font-size: large;
                }

                .edit-profile-btn {
                  padding: 10px 20px;
                  font-size: large;
                  width: 100%;
                  justify-content: center;
                }

                .menu-card {
                  padding: 20px 16px;
                }

                .menu-icon {
                  width: 50px;
                  height: 50px;
                }

                .menu-icon i {
                  font-size: 20px;
                }

                .menu-label {
                  font-size: large;
                }

                .menu-arrow {
                  font-size: 12px;
                }
              }

              @media (max-width: 480px) {
                .profile-title {
                  font-size: large;
                }

                .menu-card {
                  padding: 16px 12px;
                }

                .menu-label {
                  font-size: large;
                }
              }

              /* Hover optimizations for touch devices */
              @media (hover: none) and (pointer: coarse) {
                .menu-card:hover,
                .edit-profile-btn:hover {
                  transform: none;
                }

                .menu-card::before {
                  opacity: 1;
                }

                .menu-arrow {
                  opacity: 1;
                }
              }
            `}</style>
          </React.Fragment>
        </>
      )}
    </>
  );
}

export default React.memo(More);